/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Current_LabelInputs */

const en_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const fr_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuel`)
};

const de_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

const it_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attuale`)
};

const ru_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий`)
};

const es_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const zh_cn2_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前的`)
};

const ja_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在`)
};

const hi_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मौजूदा`)
};

const pt_pt2_timing_sync_current_label = /** @type {(inputs: Timing_Sync_Current_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual`)
};

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Timing_Sync_Current_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_current_label = /** @type {((inputs?: Timing_Sync_Current_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Current_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_current_label(inputs)
	if (locale === "de") return de_timing_sync_current_label(inputs)
	if (locale === "it") return it_timing_sync_current_label(inputs)
	if (locale === "ru") return ru_timing_sync_current_label(inputs)
	if (locale === "es") return es_timing_sync_current_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_current_label(inputs)
	if (locale === "ja") return ja_timing_sync_current_label(inputs)
	if (locale === "hi") return hi_timing_sync_current_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_current_label(inputs)
	return en_timing_sync_current_label(inputs)
});